<template>
    <div class="play_userPop">
        <div class="olay_pop">
            <div class="popup-header">
                <!--
                <div class="header-logo">
                    <span>{{ $t('Personal Center') }}</span>
                </div>
                -->

                <div @click="close" class="inf_close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            
            <div class="inf_bott olap_pop_gundong">
              <!--
                <div class="selector">
                    <img src="@/static/images/logo.png" alt="">

                    <div @click="changeOption('存款')" :class="{ 'inf_select': selectTile == '存款' }">
                        {{ $t('存款') }}
                    </div>
                    <div @click="changeOption('取款')" :class="{ 'inf_select': selectTile == '取款' }">
                        {{ $t('取款') }}
                    </div>
                    <div @click="changeOption('游戏记录')" :class="{ 'inf_select': selectTile == '游戏记录' }">
                        {{ $t('游戏记录') }}
                    </div>
                    <div @click="changeOption('交易记录')" :class="{ 'inf_select': selectTile == '交易记录' }">
                        {{ $t('交易记录') }}
                    </div>
                </div>
              -->

                <!--  GAME RECORD-->
                <div class="inf_content" v-loading="loading" element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)">
                    <div class="game_log" v-if="selectTile == '游戏记录'">
                        <div class="gameTitle">
                            <table border="0" cellspacing="0">
                                <tr class="table-title">
                                    <td>{{ $t("游戏品牌") }}</td>
                                    <td><span class="second-game-table">{{ $t("游戏名称") }}</span></td>
                                    <td><span class="third-game-table">{{ $t("下注时间") }}</span></td>
                                    <td><span class="fourth-game-table">{{ $t("下注金额") }}</span></td>
                                    <td>{{ $t("输赢金额") }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="tableDataGame.length != 0" class="have_data">
                            <table border="0" cellspacing="30">
                                <tr class="table-title" v-for="(item, index) in tableDataGame" :key="index">
                                    <td>{{ item.api_name }}</td>
                                    <td><span class="second-row-table">{{ $t(`${item.gameName}`) }}</span></td>
                                    <td >{{ item.betTime }}</td>
                                    <td><span class="fourth-row-table">{{ $t(`${item.betAmount}`) }}</span></td>
                                    <td>{{ $t(`${item.netAmount}`) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else class="noData">{{ $t("暂无数据") }}</div>
                    </div>

                    <!-- CHANGE!!!!!! -->

                    <div class="jy_log" v-if="selectTile == '交易记录'">
                        <div class="table" v-if="tableData.length != 0">
                            <div class="tr_tit">
                                <div>{{ $t("充电时间") }}</div>
                                <div>{{ $t("订单号") }}</div>
                                <div>{{ $t("充值金额") }}</div>
                                <div>{{ $t("地位") }}</div>
                                <div>{{ $t("充值方式") }}</div>
                            </div>
                            <div class="td_list" v-for="(item, index) in tableData" :key="index">
                                <div class="fisrt-row">{{ item.created_at }}</div>
                                <div class="second-row">{{ item.id }}</div>
                                <div>{{ item.money }}</div>
                                <div v-show="item.status === 1">Pending</div>
                                <div v-show="item.status === 2">Success</div>
                                <div v-show="item.status === 3">Failed</div>
                                <div>{{ item.payment_type }}</div>
                            </div>
                        </div>
                        <div v-else class="noData">{{ $t("暂无数据") }}</div>
                    </div>

                    <!-- DEPOSIT -->
                    <div v-if="selectTile == '存款' && selectPay2 != null && selectPay != null" class="deposit-container">                        
                        <div class="pay_specific">

                            <!-- <div class="pay">
                                <div class="pay_type" @click="selectPay = item" :class="selectPay == item ? 'select' : ''"
                                    v-for="(item, index) in pay" :key="index">
                                    <img :src="item.currencyIcon" alt="" srcset="" />
                                </div>
                            </div> -->
                            
                            <h2>{{ $t("充值") }}</h2>

                            <!-- 
                            <hr>
                            
                            <div class="showData">
                                <div class="mode_deposit">
                                  <img :src="selectPay2.currencyIcon" alt="" srcset="" width="50"/>
                                </div>
                            </div>
                             -->

                            <hr>
                                                        
                            <div class="payment-container">
                              <div class="pay">
                                  <div class="pay_type" @click="selectPay = item" :class="selectPay == item ? 'select' : ''"
                                      v-for="(item, index) in pay" :key="index">
                                      {{ item.type_text }}
                                  </div>
                              </div>
                            </div>  

                            <hr>

                            <p>{{ $t('存款金额')}}</p>
                            <div class="money_number">
                                <div class="paydeposit">
                                    <div class="pay_type" @click="selectDeposit(item.amount)" v-for="(item, index) in deposit" :key="index">
                                        {{ item.amount }}
                                    </div>
                                </div>

                                <div class="number_input">
                                    <div class="bank_in_text">{{ $t("充值金额") }}：</div>
                                    <div style="width: 100%;">
                                        <input :placeholder="$t('Limit') + ': ' + selectPay2.min + ' - ' + selectPay2.max" v-model="post_data.money" type="text" />
                                    </div>
                                </div>
                                <div class="submit-container">
                                    <div @click="submitPay" class="money_submit">
                                        {{ $t("充值") }}
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <!-- Withdraw -->
                    <div class="withdraw_box" v-if="selectTile == '取款' && selectPay2 != null && selectPay != null">
                      <!-- <div class="box_header">
                        <div class="bank_in_text">{{ $t("取款") }}</div>
                      </div> -->
                      <div class="box_content">
                        <div class="form ababab">
                            <div class="showData">
                                <table width="100%" style="text-align: left;">
                                    <tr>
                                        <th width="15%" rowspan="2"><img :src="selectPay2.currencyIcon" alt="" srcset="" width="50" style="vertical-align: middle;"/></th>
                                        <th width="85%">{{ $t("最小") }}: {{ selectPay2.min }}</th>
                                    </tr>
                                    <tr>
                                        <th width="70%">{{ $t("最大") }}: {{ selectPay2.max }}</th>
                                    </tr>
                                </table>
                            </div>
                            <div class="pay_specific">
                                <div class="showData d-block">                                    
                                        <div class="money_withdraw">
                                            <div class="number_input">
                                                <el-form ref="formt" :model="formData" :rules="rules">
                                                <div class="align-div"> 
                                                    <div class="withdraw_in_text">{{ $t("收款名称") }}：</div>
                                                    <div>
                                                        <el-form-item  prop="name">
                                                            <el-input v-model="formData.name"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                                <div class="align-div"> 
                                                    <div class="withdraw_in_text">{{ $t("账号类型") }}：</div>
                                                    <div>
                                                        <el-form-item prop="payment_type">
                                                            <el-select v-model="formData.payment_type" :placeholder="$t('请选择')">
                                                                <el-option v-for="item in options" :key="item.value" :label="item.label"
                                                                    :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                                <div class="align-div"> 
                                                    <div class="withdraw_in_text">{{ $t("收账账号") }}：</div>
                                                    <div>
                                                        <el-form-item prop="account">
                                                            <el-input v-model="formData.account"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                                <div class="align-div"> 
                                                    <div class="withdraw_in_text">{{ $t("金额") }}：</div>
                                                    <div>
                                                        <el-form-item prop="money">
                                                            <el-input v-model="formData.money"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                                <div class="align-div"> 
                                                    <div class="withdraw_in_text">{{ $t("提现密码") }}：</div>
                                                    <div>
                                                        <el-form-item prop="qk_pwd">
                                                            <el-input v-model="formData.qk_pwd"></el-input>
                                                        </el-form-item>
                                                    </div>
                                                </div>
                                                <!-- <div class="submit-container">
                                                    <div @click="submitPay" class="money_submit">
                                                        {{ $t("充值") }}
                                                    </div>
                                                </div> -->

                                                <el-form-item>
                                                    <el-button :disabled="buttonWithdraw" @click="submitMoney('formt')" class="money_submit">
                                                        {{ $t("提现") }}
                                                    </el-button>
                                                </el-form-item>
                                            </el-form>
                                            </div>
                                        </div>

                                </div>
                            </div>

                        </div>
                      </div>
                    </div>
                    <!-- Withdraw -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { payments, axiosOnline, recharge, gamerecord, transactionRecord, Withdraw } from "@/api/apiIndex.js";
export default {
    name: "Gamenew2infigaUserpop",
    props: {
        userPopShow: {
            type: Boolean,
            default: false
        },
        righttop: {
            type: String,
            default: "Deposit"
        }
    },
    watch: {
        userPopShow() {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        },
        selectPay: function (newVal, oldVal) {
            if (newVal) {
                for (let index = 0; index < this.xxData.length; index++) {
                    if (this.xxData[index].type == newVal.type) {
                        this.selectPay2 = this.xxData[index];
                    }
                }
            }
        },
        "post_data.money" (value) {
            if (!value) {
                this.myNums = []
            }
        },
    },
    data() {
        return {
            myNums: [],
            deposit: [
                { "amount": 10 },
                { "amount": 30 },
                { "amount": 50 },
                { "amount": 100 },
                { "amount": 200 },
                { "amount": 500 },
                { "amount": 1000 },
                { "amount": 5000 },
            ],
            loading: false,
            buttonWithdraw: false,
            options: [],
            formData: {
                name: '',//名称
                money: '',//钱
                account: '',//账号
                qk_pwd: '',//密码
                payment_type: '',//类型
                // member_bank_id:''//CPF
            },
            rules: {
                name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
                money: [{ required: true, message: this.$t('请输入提现金额'), trigger: 'blur' }],
                account: [{ required: true, message: this.$t('请输入账号'), trigger: 'blur' }],
                qk_pwd: [{ required: true, message: this.$t('请输入密码'), trigger: 'blur' }],
                payment_type: [{ required: true, message: this.$t('请选择类型'), trigger: 'blur' }],
                // member_bank_id:[{ required: true, message: this.$t('请输入CPF'), trigger: 'blur' }]
            },
            activeNames: [],
            userInfo: {},
            selectTile: "Deposit",
            pay: null,
            txPay: null,
            selectPay: null,
            selectPay2: null,
            xxData: [],
            // 提交充值的数据
            post_data: {
                money: null,
                payment_desc: "",
                payment_id: "",
                payment_type: "",
                bank_code: "PIX",
                attach: ""
            },
            // 游戏记录
            pageGame: "1",
            last_pageGame: "1",
            tableDataGame: "",
            // 交易记录
            page: "1",
            last_page: "1",
            tableData: []
        };
    },
    async created() {
        this.changeOption(this.righttop);
    },
    methods: {
        selectDeposit(data) {
            this.myNums.push(data)
            let sum = 0
            for (let i = 0; i < this.myNums.length; i++ ) {
                sum += this.myNums[i];
            }
            this.post_data.money = sum
        },
        changeOption(text) {
            if (this.selectTile == text) return
            this.selectTile = text
            this.loading = true;
            switch (this.selectTile) {
                case '存款':
                    this.getPay();
                    this.getPay2();
                    break;
                case '取款':
                    this.getPay();
                    this.getPay2();
                    break;
                case '游戏记录':
                    this.ShowAxiosGame();
                    break;
                case '交易记录':
                    this.ShowAxios();
                    break;
                default:
                    break;
            }
        },
        // 提款提交
        async submitMoney(formName) {
            this.$refs[formName].validate((valid) => {
                // if (valid) {
                //     let obj = { ...this.formData }
                //     obj.payment_type = this.selectPay.type + '-' + this.formData.payment_type
                //     Withdraw(obj).then(res => {
                //         if (res.code == 200) {
                //             this.$message.success(this.$t("提现成功"));
                //         } else {
                //             this.$message.error(res.msg);
                //         }

                //     })
                // } else {
                //     this.$message.error(this.$t("请输入正确的参数"));
                //     return false;
                // }
                if (valid) {
                    this.buttonWithdraw = true
                    let obj = { ...this.formData }
                    obj.payment_type = this.selectPay.type + '-' + this.formData.payment_type
                    this.withDrawApi(obj)
                }
            });
        },
        async withDrawApi (obj) {
            const apiResponse = await Withdraw(obj)
            if (apiResponse.name === "AxiosError") {
                this.buttonWithdraw = false
            } else {
                console.log("SUCCESS!", apiResponse)
            }
        },
        // 交易记录
        ShowAxios() {
            let time = new Date();
            let threeMonthsAgo = new Date(time.setMonth(time.getMonth() - 3));
            time = new Date();
            let obj = {
                created_at: [
                    threeMonthsAgo.toLocaleDateString().replaceAll("/", "-") +
                    " 00:00:00",
                    time.toLocaleString().replaceAll("/", "-")
                ],
                money_type: "",
                operate_type: "",
                page: 1
            };
            transactionRecord(obj)
                .then(res => {
                    this.page = res.data.current_page;
                    this.last_page = res.data.last_page;
                    this.tableData = res.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    // 
                });
        },
        // 游戏记录
        ShowAxiosGame() {
            let time = new Date();
            let obj = {
                betTime: [
                    time.toLocaleDateString().replaceAll("/", "-") + " 00:00:00",
                    time.toLocaleString().replaceAll("/", "-")
                ],
                limit: 30,
                page: 1
            };
            gamerecord(obj)
                .then(res => {
                    this.pageGame = res.data.current_page;
                    this.last_pageGame = res.data.last_page;
                    this.tableDataGame = res.data.data;
                    this.loading = false;
                })
                .catch(err => {
                    // 
                });
        },
        // 支付方式
        getPay() {
            this.options = [];
            return new Promise((resolve, reject) => {
                payments({
                    lang: JSON.parse(localStorage.getItem("language")).value,
                    domain: location.hostname =='localhost'? '63s.online' : location.hostname
                })
                    .then(res => {
                        this.loading = false;
                        if (res.code == 200) {
                            // 充值用
                            this.pay = res.data.payment_type.filter(v => {
                                return v.type_text.indexOf('-') == -1
                            });
                            // 提现用
                            this.txPay = res.data.payment_type.filter(v => {
                                return v.type_text.indexOf('-') != -1
                            });
                            this.txPay.forEach(v => {
                                v.type = v.type.slice(0, v.type.indexOf('-'))
                            })
                            this.txPay = this.arrQuchong(this.txPay, 'type')
                            let arr = res.data.payment_type.filter(v => {
                                return v.type_text.indexOf('-') != -1
                            })
                            arr.forEach(v => {
                                let type = v.type_text.slice(v.type_text.indexOf('-') + 1);
                                this.options.push({ label: type, value: type })
                            })
                            // 被选择项
                            if (this.selectTile == this.$t('取款')) {
                                this.selectPay = this.txPay[0];
                            } else {
                                this.selectPay = this.pay[0];
                            }
                            resolve();
                        } else {
                            this.$message.error(res.message);
                            reject();
                        }
                    })
                    .catch(err => {
                        // 返回code为401 token过期 公共js
                        if (this.comJs.tokenIsExpire(err.response.data.code)) {
                            return;
                        }
                        reject();
                    });
            });
        },
        // 去重
        arrQuchong(array, key) {
            const _set = [...new Set(array.map(e => e[key]))];
            let deArray = [];
            _set.map(item => {
                deArray.push(array[array.findIndex(val => val[key] === item)])
            })
            return deArray
        },
        // 具体支付限制
        getPay2() {
            return new Promise((resolve, reject) => {
                let axOnline = {
                    lang: JSON.parse(localStorage.getItem("language")).value,
                    domain: location.hostname =='localhost'? '63s.online' : location.hostname
                };
                axiosOnline(axOnline)
                    .then(res => {
                        this.loading = false;
                        if (res.code == 200) {
                            this.xxData = res.data;
                            for (let index = 0; index < this.xxData.length; index++) {
                                if (this.selectPay.type == this.xxData[index].type) {
                                    this.selectPay2 = this.xxData[index];
                                }
                            }
                            resolve();
                        } else {
                            this.$message.error(res.message);
                            reject();
                        }
                    })
                    .catch(err => {
                        // 返回code为401 token过期 公共js
                        if (this.comJs.tokenIsExpire(err.response.data.code)) {
                            return;
                        }
                        reject();
                    });
            });
        },
        // 提交支付
        submitPay() {
            if (this.isSub) return;
            if (this.money == "") {
                this.$message.error(this.$t("请输入金额"));
                return;
            }
            if (this.money < this.selectPay2.min) {
                this.$message.error(
                    `${this.$t("金额不得小于")} ${this.selectPay2.min}`
                );
                return;
            }
            if (this.money > this.selectPay2.max) {
                this.$message.error(
                    `${this.$t("金额不得大于")} ${this.selectPay2.max}`
                );
                return;
            }
            this.post_data.payment_desc = this.selectPay2.desc;
            this.post_data.payment_type = this.selectPay2.type;
            if (this.post_data.attach == "") {
                this.post_data.attach = "12345678910";
            }
            recharge(this.post_data)
                .then(res => {
                    this.isSub = false;
                    if (res.code == 200) {
                        if ("pay_url" in res) {
                            window.location.href = res.pay_url;
                        }
                    } else {
                        this.post_data.attach = "";
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.isSub = false;
                    if (this.comJs.tokenIsExpire(err.response.data.code)) {
                        return;
                    }
                    this.post_data.attach = "";

                    this.$message.error(err.response.data.message);
                });
        },
        close() {
            this.$emit("changeShowLogin", false);
        }
    }
};
</script>

<style lang="less" scoped>

.box_content {
    margin: 25px;
    border-radius: 10px;
    // background: #0E2140;
}


.paydeposit {
    gap: 15px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    .pay_type {
        color: #FFF;
        display: flex;
        align-items: center;
        border-radius: 10px;
        border: 1px solid #3F3F3F;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        font-size: 14px;
        cursor: pointer;
        padding: 17px 10px;
        justify-content: center;
        background-color: #002B34;

        &:hover {
            background: #44C1E9;
        }
    }

    .select {
        background: #2B2D42 !important;
    }
}

.olap_pop_gundong {
    overflow-y: auto;
}

/* 滚动条宽 */
.olap_pop_gundong::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

/* 滚动条 背景颜色 */
.olap_pop_gundong::-webkit-scrollbar-track-piece {
    background: #385659;
}

/* 滚动条 颜色 */
.olap_pop_gundong::-webkit-scrollbar-thumb {
    background: #a3a6a0;
    border-radius: 8px;
}

.play_userPop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9;
    max-width: 486px;

    .olay_pop {
      width: 96%;
      height: 95vh;
      position: relative;
      top: 20px;
      background: #C3F9FF;
      z-index: 1001;
      border-radius: 20px;
      color: #38516A;
      margin: 0 auto;      

      hr {
        border-top: 1px solid #FFF;
        border-bottom: 0;
        margin: 15px auto;
      }

      .popup-header{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          border-radius: 20px 20px 0 0;
          position: absolute;


          .header-logo{
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              padding: 12px 25px;
              background: #3D0000;
              width: 250px;
              border-radius: 30px 0 0 0;

              img {
                  height: 36px;
              }
              span {
                  color: #FF6363;
              }
          }

          .inf_close {
              font-size: 20px;
              background: none;
              padding: 10px 20px;
              border-radius: 10px 10px 0 0;

              i {
                cursor: pointer;
                color: #6A6A6A;
                padding: 10px;
                border-radius: 100%;
              }
          }
      }

      .inf_bott {
          height: 100%;
          display: flex;
          padding: 0;
          border-radius: 0 0 10px 10px;
          overflow-y: auto;

          .selector{
              width: 30%;
              display: flex;
              flex-direction: column;
              gap: 10px;
              background: rgba(127, 127, 127, 0.30);
              border-right: 3px solid #202429;
              padding: 0 20px;

              img {
                margin: 40px auto 30px;
                max-width: 230px;
              }

              div {
                padding: 20px;
                cursor: pointer;
                color: #FFF;
                font-size: 20px;
                font-weight: 500;
                line-height: 20.8px;
                text-align: center;       
                margin: 0 auto;  
                border-radius: 10px;
                border: 1px solid #7B7B7B;
                background: #343434;
                width: 100%;

                  &:hover {
                    color: #15ACFC;
                  }         
              }

              .inf_select {
                background: linear-gradient(180deg, #15ACFC 0%, #0A8BFD 100%), #343434;

                &:hover {
                  color: #FFF;
                }
              }
          }

          .inf_content {
              min-height: 90%;                
              width: 100%;

              .game_log {
                margin: 50px 10px 20px;
                padding: 10px;
                color: #FFF;
                border-radius: 10px;
                border: 2px solid rgba(255, 255, 255, 0.5);
                background-color: #38516a;

                td {
                  font-size: 12px;
                  line-height: 18px;
                }
              }

              .noData {
                  text-align: center;
                  margin: 10px 0;
              }
          }
      }

    }
}

.game_log {
    .gameTitle {
        margin-top: 10px;
        border-bottom: 1px solid #FFF;
        width: 100%;
        padding-bottom: 15px;

        table {
            width: 100%;
        }
    }

    .have_data {
        width: 100%;

        table {
            width: 100%;
        }
    }
}

.jy_log {    
  margin: 50px 10px 20px;
  padding: 10px;
  color: #FFF;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background-color: #38516a;
  font-size: 12px;
  line-height: 14px;

  .tr_tit {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border-bottom: 1px solid white;
    line-height: 15px;
    gap: 15px;
    padding-bottom: 15px;
    margin-bottom: 15px;

    div {
      width: 20%;
    }
  }   

  td {
    font-size: 12px;
    line-height: 18px;
  }

  .td_list {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    line-height: 15px;
    gap: 15px;
    margin-bottom: 10px;

    div {
      width: 20%;
    }
  }
}

.deposit-container{
    display: flex;
    gap: 20px;

    .payment-container {
      border-radius: 10px;      
      margin: 20px auto;
      
      .pay {      
          display: flex;
          align-items: center;
      }

      .pay_type {
          width: 120px;
          padding: 10px 0;
          margin: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          cursor: pointer;
          font-size: 14px;
          color: #FFF;
          font-weight: 600;
          border-radius: 10px;
          background: #777;
          

          &.select {
            background: #44C1E9;
          }
      }
      
    }

    .el-form {
        padding: 25px;

        .el-col {
            padding: 0 15px;
        }
    }

    .pay_specific {
        margin: 50px auto 0;
        width: calc(100% - 30px);
        padding: 15px 0;
        border-radius: 5px;
    }

    .bank {
        width: 100%;
        color: #fff;
        padding: 15px;

        .bank_in_text {
            width: 150px;
        }

        .bank_select {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
        }

        .bank_type {
            display: flex;
        }

        .one,
        .two {
            background: rgba(255, 255, 255, 0.1);
            padding: 5px 10px;
            border-radius: 5px;
            margin-right: 10px;
            cursor: pointer;
        }

        .select {
            background: transparent !important;
            box-shadow: 0px 0px 5px 2px rgb(54 193 124) !important;
        }

        .bank_input {
            display: flex;

            input {
                outline: none;
                border: none;
                height: 24px;
                width: 200px;
                background: #083E5B;
                border-radius: 5px;
                box-sizing: border-box;
                flex: 1;
                padding: 0 10px;
                 color: #9CC9D9;
            }

            input:focus {
                border: 1px solid skyblue;
            }
        }
    }

    .money_number {
        display: flex;
        flex-direction: column;
        color: #38516A;
        padding: 0 15px;
        margin: 20px 0 10px 0;

        .number_input {          
            margin-top: 20px;
        }

        .submit-container{
            display: flex;
            justify-content: center;
        }
            
        .money_submit {
            font-family: "Saira", sans-serif;
            font-size: 16px;          
            color: #FFFFFF;
            height: 44px;
            border: none;
            cursor: pointer;
            text-align: center;
            padding: 10px 50px;
            border-radius: 10px;
            background: linear-gradient(180deg, #6ADFFF 0%, #093774 100%); 
            margin: 20px 0 30px 0;

            &:hover {
              background: #38516a;
            }
        }
    }

    /deep/.el-form-item__label {
        color: white!important;
    }

    /deep/.el-form-item__content {
        line-height: 30px;
        width: 100%;

        input {
            border: 0;            
            color: #FFF;
            padding: 0 10px;
            border-radius: 15px;
            border: 1px solid #FFF;
            background-color: #000C18;
        }

        .el-button {
            font-family: "Saira", sans-serif;
            font-size: 16px;
            border-radius: 9px;
            background: linear-gradient(180deg, #8F00FF 0%, #EB00FF 100%), linear-gradient(180deg, #17FFC7 0%, #03628A 100%);
            box-shadow: 0px 0px 25.5px -4px #E201FF;
            color: #FFF;
            width: 100%;
            height: 44px;
            border: none;
        }

        .el-select {
            width: 100%;
        }
    }
}

.showData {
    color: #38516A;
    padding: 15px 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    
    .mode_deposit {
      background-color: #333;
      padding: 10px 50px;
      border-radius: 10px;
      display: flex;
      align-items: center;

      img {
        max-height: 30px;
        width: auto;
      }
    }
}
.bank_in_text {
  color: #38516a;
  margin-bottom: 5px;
}
.number_input {

  input {
      outline: none;
      height: 48px;
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      font-size: 14px;
      color: #252525;
      padding: 0 10px;
      border-radius: 10px;
      border: 1px solid #555;
      background-color: transparent;

      &::placeholder {
          color: #606F8B;
      }
  }
}

.recharge,
.ababab {
    margin-top: 60px;

    .el-form {

        .el-col {
        }
    }

    .pay_specific {
        margin: auto;
        padding: 0 0 15px;
    }

    .pay {
        display: grid;
        grid-template-rows: auto;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        padding: 15px;

        .pay_type {
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          cursor: pointer;
          background: linear-gradient(180deg, #2C3064 0%, #1D1C39 100%);
          border-radius: 10px;

          img {
              height: 80%;
          }
        }

        .select {            
            background: linear-gradient(180deg, #2C3064 0%, #1D1C39 100%);
            border-radius: 10px;
        }
    }

    .paydeposit2 {
        display: flex;
        flex-direction: row;
        padding: 15px;

        .pay_type {
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
            border: 1px solid rgba(255, 255, 255, 0.04);
            background: #2C3064;
            box-shadow: 0px 1px 0px 0px rgba(255, 255, 255, 0.08) inset;
            font-size: 12px;
            cursor: pointer;
            margin-right: 20px;
            width: 300px;
        }

        .select {
            background: #2C3064 !important;
        }
    }

    .withdraw_in_text {
        color: #38516A;
    }

    .bank {
        width: 100%;
        color: #fff;
        padding: 15px;

        .bank_select {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
        }

        .bank_type {
            display: flex;
        }

        .one,
        .two {
            background: rgba(255, 255, 255, 0.1);
            padding: 5px 10px;
            border-radius: 5px;
            margin-right: 10px;
            cursor: pointer;
        }

        .select {
            background: transparent !important;
            box-shadow: 0px 0px 5px 2px rgb(54 193 124) !important;
        }

        .bank_input {
            display: flex;

            input {
                outline: none;
                border: none;
                height: 24px;
                width: 200px;
                background: #6D6C7C;
                border-radius: 5px;
                box-sizing: border-box;
                flex: 1;
                padding: 0 10px;
                 color: #FFF;
            }

            input:focus {
                border: 1px solid skyblue;
            }
        }
    }

    .money_number {
        display: flex;
        flex-direction: column;
        color: #fff;
        padding: 5px 25px 20px 25px;

        .number_input {
        }

        .money_submit {
            font-size: 15px;
            border-radius: 10px;
            background: linear-gradient(180deg, #6ADFFF 0%, #093774 100%);  

            color: #FFFFFF;
            width: 400px;
            height: 44px;
            font-weight: 500;
            cursor: pointer;
            text-align: center;
            padding: 10px 50px;
            margin: auto;
            margin-top: 20px;

            &:hover {                
                background: #38516a;
            }
        }
    }

    .money_withdraw {
        display: flex;
        flex-direction: column;
        color: #fff;
        margin: 10px 0 10px 0;

        .number_input {
            display: flex;
            flex-direction: column;

            .align-div {
            }
        }

        .money_submit {
            font-family: "Saira", sans-serif;
            font-size: 15px;
            border-radius: 10px;
            background: linear-gradient(180deg, #6ADFFF 0%, #093774 100%); 
            color: #FFFFFF;
            height: 44px;

            cursor: pointer;
            text-align: center;
            padding: 10px 50px;
            border-radius: 5px;
            margin: auto;
        }
    }

    .quick {
        margin: 15px 0;
        background: #1D1C39;
        border-radius: 10px !important;
    }

    /deep/.el-form-item__label {
        color: white;
    }

    /deep/.el-form-item__content {
        line-height: 30px;
        margin: auto;

        input {
          color: #FFF;
          padding: 0 10px;
          border-radius: 10px;
          border: 1px solid #555;
          background-color: transparent;
        }

        .el-button {
            font-size: 16px;
            border-radius: 10px;
            background: linear-gradient(180deg, #6ADFFF 0%, #093774 100%);
            color: #FFFFFF;
            width: 100%;
            height: 44px;
            border: none;
        }

        .el-button:hover {
            background: #38516a;
        }

        .el-select {
            width: 100%;
        }
    }
}

tr.table-title {
    display: flex;
    justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// src/components/infigaUserpop.vue